export default "__VITE_ASSET__7af05dbd__"